import React, { Fragment } from 'react';
import { Home, Users, Gift } from 'react-feather';
import { Link } from 'react-router-dom'
import { IdcardOutlined } from '@ant-design/icons';
 
const Title = props => {
    const breadcrumb = props;

    return (
        <Fragment>
            <div className="container-fluid">
                <div
                    className="page-header"
                    style={{ paddingTop: "10px", paddingBottom: "10px" }}
                >
                    <div className="row">
                        <div className="col">
                            <div className="page-header-left">
                                <h3>{breadcrumb.title}</h3>
                                <ol className="breadcrumb pull-right">
                                    <li className="breadcrumb-item">
                                        <Link to="/card">
                                            <IdcardOutlined />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">{breadcrumb.parent}</li>
                                    {
                                        breadcrumb.child
                                        ?
                                        <li className="breadcrumb-item active">{breadcrumb.child}</li>
                                        :
                                        null
                                    }
                                </ol>
                            </div>
                        </div>
                        {
                            breadcrumb.action
                            ?
                            <div
                                className="col-auto"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                }}
                            >
                                {breadcrumb.action}
                            </div>
                            :
                            null
                        }
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Title;
